module.exports = __webpack_public_path__ + "assets/img/headerImg-2.0c7123c2.jpg";